import { eqBy,prop, unionWith } from "ramda";
import { projectDefaultState } from "../../project.duck";

export const defaultScopeId = "v3.groups";
export const contextKey = "project";

export const LOAD_SUCCEEDED = "GROUPS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "GROUPS/LOAD_FAILED";
export const LOAD_REQUESTED = "GROUPS/LOAD_REQUESTED";
export const LOAD_ALL_SUCCEEDED = "GROUPS/LOAD_ALL_SUCCEEDED";
export const LOAD_ALL_FAILED = "GROUPS/LOAD_ALL_FAILED";
export const LOAD_ALL_REQUESTED = "GROUPS/LOAD_ALL_REQUESTED";
export const ADD_SUCCEEDED = "GROUPS/ADD_SUCCEEDED";
export const ADD_FAILED = "GROUPS/ADD_FAILED";
export const ADD_REQUESTED = "GROUPS/ADD_REQUESTED";
export const UPDATE_SUCCEEDED = "GROUPS/UPDATE_SUCCEEDED";
export const UPDATE_FAILED = "GROUPS/UPDATE_FAILED";
export const UPDATE_REQUESTED = "GROUPS/UPDATE_REQUESTED";
export const DELETE_SUCCEEDED = "GROUPS/DELETE_SUCCEEDED";
export const DELETE_FAILED = "GROUPS/DELETE_FAILED";
export const DELETE_REQUESTED = "GROUPS/DELETE_REQUESTED";
export const UPDATE_USERS_SUCCEEDED = "GROUPS/UPDATE_USERS_SUCCEEDED";
export const UPDATE_USERS_FAILED = "GROUPS/UPDATE_USERS_FAILED";
export const UPDATE_USERS_REQUESTED = "GROUPS/UPDATE_USERS_REQUESTED";
export const REMOVE_USERS_SUCCEEDED = "GROUPS/REMOVE_USERS_SUCCEEDED";
export const REMOVE_USER_FAILED = "GROUPS/REMOVE_USER_FAILED";
export const REMOVE_USER_REQUESTED = "GROUPS/REMOVE_USER_REQUESTED";
export const ADD_USERS_SUCCEEDED = "GROUPS/ADD_USERS_SUCCEEDED";
export const ADD_USERS_FAILED = "GROUPS/ADD_USER_FAILED";
export const ADD_USERS_REQUESTED = "GROUPS/ADD_USER_REQUESTED";

const mergeGroupsById = unionWith(eqBy(prop("id")));
const findById = groupId => ({ id }) => groupId === id;

// eslint-disable-next-line complexity, max-statements
export default (
    state = projectDefaultState(),
    { type, data }
) => {
    switch (type) {
    case LOAD_ALL_REQUESTED:
    case ADD_REQUESTED:
    case LOAD_REQUESTED: {
        ++state.loading;
        return state;
    }
    case REMOVE_USER_REQUESTED:
    case ADD_USERS_REQUESTED:
    case UPDATE_USERS_REQUESTED:
    case UPDATE_REQUESTED: {
        ++state.updating;        
        const { id, groupId } = data;
        const matchId = id || groupId;
        const group = state.groups.find(findById(matchId));
        if (group) {
            Object.assign(
                group,
                {
                    updating: true,
                }
            );
        }
        return state;
    }
    case DELETE_REQUESTED: {
        ++state.deleting;        
        const { id } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                {
                    deleting: true,
                }
            );
        }
        return state;
    }
    case LOAD_ALL_FAILED:
    case ADD_FAILED:
    case LOAD_FAILED: {
        --state.loading;
        const { id } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                {
                    loading: false,
                }
            );
        }
        state.errors.push({ error: data, type });
        return state;
    }
    case DELETE_FAILED: {
        --state.deleting;
        const { id } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                {
                    deleting: false,
                }
            );
        }
        state.errors.push({ error: data, type });
        return state;
    }
    case REMOVE_USER_FAILED:
    case UPDATE_USERS_FAILED:
    case ADD_USERS_FAILED:
    case UPDATE_FAILED: {
        --state.updating;
        const { id } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                {
                    updating: false,
                }
            );
        }
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_ALL_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.groups = mergeGroupsById(
            data,
            state.groups
        );
        return state;
    }
    case REMOVE_USERS_SUCCEEDED:
    case UPDATE_USERS_SUCCEEDED:
    case ADD_USERS_SUCCEEDED:
    case UPDATE_SUCCEEDED: {
        --state.updating;
        state.hasInitialData = true;
        const { id, ...properties } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                properties,
                {
                    updating: false,
                }
            );
        } else {
            state.groups.push(data);
        }
        return state;
    }
    case LOAD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        
        const { id, ...properties } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                properties,
                {
                    loading: false,
                }
            );
        } else {
            state.groups.push(data);
        }
        return state;
    }
    case ADD_SUCCEEDED: {
        --state.loading;
        const { id, ...properties } = data;
        const group = state.groups.find(findById(id));
        if (group) {
            Object.assign(
                group,
                properties,
            );
        } else {
            state.groups.push(data);
        }
        return state;
    }
    case DELETE_SUCCEEDED: {
        const { id } = data;
        state.groups.splice(state.groups.findIndex(findById(id)), 1);
        --state.deleting;
        return state;
    }
    default:
        return state;
    }
};

export const successLoadGroup = data => ({ type: LOAD_SUCCEEDED, data });
export const failLoadGroup = data => ({ type: LOAD_FAILED, data });
export const requestLoadGroup = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });

export const successLoadAllGroups = data => ({ type: LOAD_ALL_SUCCEEDED, data });
export const failLoadAllGroups = data => ({ type: LOAD_ALL_FAILED, data });
export const requestLoadAllGroups = (data, resolve, reject) => ({ type: LOAD_ALL_REQUESTED, data, resolve, reject });

export const successAddGroup = data => ({ type: ADD_SUCCEEDED, data });
export const failAddGroup = data => ({ type: ADD_FAILED, data });
export const requestAddGroup = (data, resolve, reject) => ({ type: ADD_REQUESTED, data, resolve, reject });

export const successUpdateGroup = data => ({ type: UPDATE_SUCCEEDED, data });
export const failUpdateGroup = data => ({ type: UPDATE_FAILED, data });
export const requestUpdateGroup = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });

export const successUpdateGroupUsers = data => ({ type: UPDATE_USERS_SUCCEEDED, data });
export const failUpdateGroupUsers = data => ({ type: UPDATE_USERS_FAILED, data });
export const requestUpdateGroupUsers = (data, resolve, reject) => ({ type: UPDATE_USERS_REQUESTED, data, resolve, reject });

export const successRemoveGroupUser = data => ({ type: REMOVE_USERS_SUCCEEDED, data });
export const failRemoveGroupUser = data => ({ type: REMOVE_USER_FAILED, data });
export const requestRemoveGroupUser = (data, resolve, reject) => ({ type: REMOVE_USER_REQUESTED, data, resolve, reject });

export const failAddGroupUsers = data => ({ type: ADD_USERS_FAILED, data });
export const successAddGroupUsers = data => ({ type: ADD_USERS_SUCCEEDED, data });
export const requestAddGroupUsers = (data, resolve, reject) => ({ type: ADD_USERS_REQUESTED, data, resolve, reject });

export const successDeleteGroup = data => ({ type: DELETE_SUCCEEDED, data });
export const failDeleteGroup = data => ({ type: DELETE_FAILED, data });
export const requestDeleteGroup = (data, resolve, reject) => ({ type: DELETE_REQUESTED, data, resolve, reject });
